module.exports = __webpack_public_path__ + "img/中国林业科学院-300x300.b6423717.jpg";